import { authService } from '@/services'

const refreshTimeout = 30 * 60 * 1000; // 30 minutes (in milliseconds)

// JWT token management functions
function urlBase64Decode(str) {
    let output = str.replace('-', '+').replace('_', '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            throw 'Illegal base64url string!';
    }
    return window.atob(output);
}

function getClaimsFromToken(token) {
    let claims = {};
    if (typeof token !== 'undefined' && token) {
        let encoded = token.split('.')[1];
        claims = JSON.parse(urlBase64Decode(encoded));
    }
    return claims;
}

export const user = {
    namespaced: true,
    state: {
        token: null, // jwt token string
        claims: {}, // jwt token claims
        user: null, // jwt user from claims
        timeout: null, // timer to refresh token
        license: null // user license information: { hasLicense: true/false, isActive: true/false, maxWorkforce: # workforce, remaining: # days }
    },
    mutations: {
        reset: state => {
            localStorage.removeItem('userToken');
            state.token = null;
            state.claims = {};
            state.user = null;
            state.license = null;
        },
        setToken: (state, token) => {
            localStorage.setItem('userToken', token);
            state.token = token;
            state.claims = getClaimsFromToken(token);
            state.user = state.claims.user;
        },
        setTimeout: (state, timeout) => {
            if (state.timeout) {
                // stop current timeout
                clearTimeout(state.timeout);
                state.timeout = null;
            }
            state.timeout = timeout;
        },
        setLicense: (state, license) => {
            console.log('Store[User]: Updating license => %s', JSON.stringify(license));
            state.license = license;
        }
    },
    actions: {
        reset: ({ commit, dispatch }) => {
            console.log('Store[User]: Resetting token');
            commit('reset');
            commit('setTimeout', null); // stop timer
        },
        load: ({ commit, dispatch }) => {
            console.log('Store[User]: Loading from local storage');

            try {
                let token = localStorage.getItem('userToken');

                if (!token) return commit('reset');
                commit('setToken', token);
                dispatch('startRefresh');
            } catch (err) {
                console.log('Store[User]: Error loading from local storage =>', err);
                commit('reset');
            }
        },
        update: ({ commit, dispatch }, token) => {
            console.log('Store[User]: Updating token => %s', JSON.stringify(token));

            try {
                if (!token) return commit('reset');
                commit('setToken', token);
                dispatch('startRefresh');
            } catch (err) {
                console.log('Store[User]: Error updating token =>', err);
                commit('reset');
            }
        },
        startRefresh: ({ commit, dispatch, state }) => {
            console.log('Store[User]: %s refresh timer', state.token ? 'Starting' : 'Stopping');

            let timeout = null;
            if (state.token) {
                timeout = setTimeout(() => { dispatch('refresh') }, refreshTimeout);
            }
            commit('setTimeout', timeout);
        },
        refresh: ({ commit, dispatch, state }) => {
            console.log('Store[User]: Refreshing token');

            if (!state.user) {
                console.log('Store[User]: No user, halting refresh');
                return false;
            }

            return authService.refreshToken(state.user)
                .then(resp => {
                    dispatch('update', resp); // sets token and refresh timer
                    dispatch('fetchLicense', true); // update license status
                })
                .catch(err => {
                    console.log('Store[User]: Error refreshing user token, setting retry');
                    dispatch('startRefresh');
                });
        },
        fetchLicense: ({ commit, state }, force) => {
            console.log('Store[User]: Fetching license');
            if (state.license && !force) {
                return Promise.resolve(state.license);
            }

            return authService.checkLicense()
                .then(data => {
                    commit('setLicense', data);
                    return data;
                }, error => {
                    return Promise.reject(error);
                });
        }
    }
}